// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"346":"7424cec8","797":"f39dc208","831":"bb783bc5"}[chunkId] + ".css";
};